export default {"src":"/_next/static/media/eon.f3795872.svg","height":192,"width":192};